import { defineMessages } from 'react-intl';

export const metadatas = {
  default: defineMessages({
    title: {
      defaultMessage: 'Best Fantasy MLB – Sorare: MLB',
    },
    description: {
      defaultMessage:
        "Collect, play and win officially licensed digital cards featuring the world's best baseball players from the Major League Baseball teams.",
    },
  }),
  market: defineMessages({
    title: {
      defaultMessage: 'Cards Market – Sorare: MLB',
    },
    description: {
      defaultMessage:
        "Discover new Sorare cards featuring the world's best Major League Baseball teams and players on Sorare: MLB",
    },
  }),
  newSignings: defineMessages({
    title: {
      defaultMessage: 'New Cards Auctions – Sorare: MLB',
    },
    description: {
      defaultMessage:
        "Find and collect Sorare cards featuring the world's best Major League Baseball teams and players on Sorare: MLB",
    },
  }),
  transfers: defineMessages({
    title: {
      defaultMessage: 'Manager Sales Market – Sorare: MLB',
    },
    description: {
      defaultMessage:
        'Find, collect and trade cards with other Sorare Managers',
    },
  }),
  team: defineMessages({
    title: {
      defaultMessage: '{team} – Team Profile – Sorare: MLB',
    },
    description: {
      defaultMessage:
        'Find all the statistics of {team}, collect and trade officially licensed digital cards of your favorite team on Sorare: MLB, the #1 Fantasy MLB game',
    },
  }),
};
